import React, { useCallback } from "react";
import { Slideout, Button, Tabs, Chip } from "@ann/web-components";
import { ChatContainer, HeaderActionsContainer, SearchContainer } from "./Chat.styled";
import { ChatPanel, HistoryPanel } from "./components";
import { ChatProvider } from "../../context/ChatContext";
import { useStore } from "../../../../../hooks";

const AGENT_ID = process.env.REACT_APP_UCP_AGENT_UUID;

const Chat = ({ open, onClose, contactId }) => {
  const { authStore } = useStore();
  const handleClose = useCallback(() => {
    onClose?.();
  }, [onClose]);

  // Configuración HTTP
  const httpOptions = {
    tenantId: authStore.currentWorkspaceUuid || "default-tenant",
    senderUuid: authStore.currentWorkspaceUuid,
    assistantUuid: AGENT_ID,
  };

  return (
    <ChatProvider
      key={contactId}
      agentId={AGENT_ID}
      communicationType="http"
      httpOptions={httpOptions}
    >
      <Tabs>
        <Slideout open={open} onClose={handleClose}>
        <Slideout.HeaderActions>
          <HeaderActionsContainer>
            {/* <Button icon="lock_open" pill size="medium" type="secondary" />

            <Button icon="openInFull" pill size="medium" type="secondary" /> */}
          </HeaderActionsContainer>
        </Slideout.HeaderActions>
        <Slideout.Header></Slideout.Header>
        <Slideout.Content>
          <ChatContainer>
            <Tabs.List>
              <Tabs.Tab index={0} iconLeft="sms">
                Chat
              </Tabs.Tab>
              <Tabs.Tab index={1} iconLeft="list">
                History
              </Tabs.Tab>
            </Tabs.List>
            {/* <SearchContainer>
              <Chip icon="search" size="medium" text="Search" variant="secondary" />
            </SearchContainer> */}

            <Tabs.Panel index={0}>
              <ChatPanel contactId={contactId} />
            </Tabs.Panel>
            <Tabs.Panel index={1}>
              <HistoryPanel contactId={contactId} />
            </Tabs.Panel>
          </ChatContainer>
        </Slideout.Content>
      </Slideout>
    </Tabs>
    </ChatProvider>
  );
};

export default Chat;
